import type { VideoContainerProps } from './index.types';
import { inject, observer } from 'mobx-react';
import { useIsSecondaryMenuVisible } from 'Modules/ui/secondaryMenu/hooks/useIsSecondaryMenuVisible';
import * as React from 'react';
import { Grid } from 'semantic-ui-react';
import { SecondaryMenu } from '../../components/shared/SecondaryMenu';
import VideoPanel from '../../components/VideoPanel';
import { VIDEO_SUBMENU_OPTIONS, VIDEO_SUBPATHS } from '../../constants/routing';
import { STORE_PERSON, STORE_UI } from '../../constants/stores';
import withRouter from '../../hocs/WithRouter';

const VideoContainer: React.FC<VideoContainerProps> = (props) => {
  const { ui, person, navigate } = props;
  const isSecondaryMenuVisible = useIsSecondaryMenuVisible();
  const canCreateMeeting = person.personAvaliableFeatures.video.enabled;

  const handleCloseDeletePopup = () => {
    ui.setDeletePopupDisplay(false);
  };

  return (
    <Grid.Column
      width={ui.containerWidth()}
      className="video-container semantic-flex-row"
      onClick={handleCloseDeletePopup}
    >
      {isSecondaryMenuVisible && (
        <SecondaryMenu
          text={canCreateMeeting ? 'Create meeting' : 'Video calls'}
          options={VIDEO_SUBMENU_OPTIONS}
          header={
            canCreateMeeting
              ? {
                  onClick: () => {
                    void navigate(VIDEO_SUBPATHS.NEW_ROOM);
                  },
                  active: window.location.pathname.includes(
                    VIDEO_SUBPATHS.NEW_ROOM
                  ),
                }
              : undefined
          }
        />
      )}
      <VideoPanel {...props} />
    </Grid.Column>
  );
};

export default inject(
  STORE_UI,
  STORE_PERSON
)(withRouter(observer(VideoContainer)));
